module.exports = __webpack_public_path__ + "static/img/tax_saas_content.81a72f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/matrix/tax_saas_content.png
// module id = kBiF
// module chunks = 34